export function mobileNav() {
    const body = $("body");
    const btnMenu = $(".btn-menu");
    const mainNav = $('.main-menu, .secondary-menu');
    const mainNavItems = mainNav.find('.menu-item-has-children');

    const backButton = `<div class="back-link">
						<button>Back</button>
					</div>`;
    let activeMenuItem;

    //burger
    btnMenu.on("click", function (e) {
        let $this = $(this);
        if (!$this.hasClass("open")) {
            $this.addClass("open");
            body.addClass("menu-opened");
        } else {
            $this.removeClass("open");
            body.removeClass("menu-opened");
        }
        mainNav.find('> li').removeClass('active').show();
        mainNav.find('> .menu-item-has-children').removeClass('active');
        e.preventDefault();
    });

    //append back button
    mainNavItems.each((i, item) => {
        const menuList = $(item).find(' > .sub-menu');
        $(menuList).append(backButton);
    });

    //close menu
    function closeDropdown(e) {
        if (!mainNavItems.has(e.target).length > 0) {
            mainNavItems.removeClass('active');
            window.removeEventListener('click', closeDropdown);
        }
    }

    //show/hide menu
    $(document).on("click", mainNav, function (e) {
        const target = $(e.target);

        if (target.closest('.menu-item-has-children > a').length) {
            e.preventDefault();
        }

        if (target.closest('.menu-item-has-children > a').length) {
            activeMenuItem = target.closest('.menu-item-has-children');
            if (body.hasClass('touch') || window.innerWidth < 1200) {
                if (!activeMenuItem.hasClass("active")) {
                    activeMenuItem.siblings().removeClass('active');
                    activeMenuItem.addClass("active");
                    window.addEventListener('click', closeDropdown);
                } else {
                    activeMenuItem.removeClass("active");
                    window.removeEventListener('click', closeDropdown);
                }
            }
        }

        if (target.closest('.back-link button').length) {
            $('.menu-item-has-children').removeClass('active');
            activeMenuItem.removeClass("active");
            activeMenuItem = activeMenuItem.closest('.menu-item-has-children.active');
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mobileNav.js